/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const GET_CURRENT_DISPUTE_DISPLAY_OBJ_PRO =
  'GET_CURRENT_DISPUTE_DISPLAY_OBJ_PRO';
export const GET_CURRENT_DISPUTE_DISPLAY_DETAIL_OBJ_PRO =
  'GET_CURRENT_DISPUTE_DISPLAY_DETAIL_OBJ_PRO';
export const GET_PLAN_TYPE_DATA_PRO = 'GET_PLAN_TYPE_DATA_PRO';
export const SEARCH_PRO = 'SEARCH_PRO';
export const SET_REFRESH_DATA_PRO = 'SET_REFRESH_DATA_PRO';
export const SET_REFRESH_DATA_PRO_DISPLAY = 'SET_REFRESH_DATA_PRO_DISPLAY';
export const GET_REBATE_PROGRAM_PRO = 'GET_REBATE_PROGRAM_PRO';
export const GET_ERROR_MSG_PRO = 'GET_ERROR_MSG_PRO';
export const GET_FROM_PRO = 'GET_FROM_PRO';
export const SET_DISPLAY_OBJ_PRO = 'SET_DISPLAY_OBJ_PRO';
export const GET_PROGRAM_AND_ELIGIBILITY = 'GET_PROGRAM_AND_ELIGIBILITY';
export const GET_REBATE_PROGRAM_NAME_PRO = 'GET_REBATE_PROGRAM_NAME_PRO';
export const GET_REBATE_QUARTER_VALUE = 'GET_REBATE_QUARTER_VALUE';
